import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Image } from "../../Image";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: /*#__PURE__*/ _jsx(Image, {
            width: 24,
            height: 22,
            src: "/images/logo.png",
            style: props.style
        })
    });
};
export default Icon;
